<template>
  <b-button variant="outline" class="thead-sort" @click="toggle">
    <slot></slot>
    <span class="thead-sort__controls">
      <span :class="['fa fa-chevron-up icon', { icon__active: sorted }]"></span>
      <span :class="['fa fa-chevron-down icon', { icon__active: sortedDesc }]"></span>
    </span>
  </b-button>
</template>

<script>
export default {
  name: 'AppTableHeadCellSort',
  props: {
    name: {
      type: String,
      default: ''
    },
    current: {
      type: String,
      default: ''
    }
  },
  computed: {
    sorted() {
      return this.name === this.current && this.current !== ''
    },
    sortedDesc() {
      return `-${this.name}` === this.current
    }
  },
  methods: {
    toggle() {
      if (this.current === '' || this.sortedDesc) {
        this.$emit('sort', this.name)
      } else {
        this.$emit('sort', `-${this.name}`)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.thead-sort {
  align-items: center;
  display: flex;
  font-weight: 500;
  line-height: 1;
  padding: 0;

  &__controls {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    margin-left: auto;
    padding-left: 6px;

    & .icon {
      opacity: 0.5;
    }

    & .icon__active {
      opacity: 1;
    }
  }
}
</style>
